const initialState = {};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PLUGINS_CATEGORIES_SUCCESS":
      return {
        ...state,
        categories: Array.isArray(action.resp?.data?.categories)
          ? action.resp.data.categories
          : state.categories,
      };

    case "GET_PLUGINS_CATEGORIES_ERROR":
      return {
        ...state,
        // categories intentionally retained
      };

    case "GET_CATEGORY_DETAILS_SUCCESS":
      return {
        ...state,
        categoryDetails: action.resp?.data,
        // categories retained ✔
      };

    default:
      return state;
  }
};

export default categoryReducer;
